import { render, staticRenderFns } from "./VerVenta.vue?vue&type=template&id=53d84dc0&scoped=true"
import script from "./VerVenta.vue?vue&type=script&lang=js"
export * from "./VerVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d84dc0",
  null
  
)

export default component.exports